const menu = {
  key: "salesorder",
  route: "/legacy/sales-orders",
  label: "sidebar.salesOrders",
  icon: "faFileInvoice",
  group: "sales",
  order: 21,
  permission: "legacy.salesorder.read"
};

export default menu;